import { useNavigate, useSearchParams } from 'react-router-dom';
// Components
import { PAGINATION_DEFAULT_NUMBER, PAGINATION_DEFAULT_SIZE } from '@zolteam/zol-admin-ui';
import { MediaGallery } from '@zolteam/zol-react-medialibrary';
// Hooks

// Locales
import fr from '../../../locales/fr.json';
// Services
import { getAllMedia, postArchiveMedia } from '../../../services/cortizol/media/mediaService';
import { postUploadMedia } from '../../../services/uploadMedia/uploadMediaService';
import { getAlllocales } from '../../../services/cortizol/locale/localeService';
import {
  deleteMediaFolder, getMyMediaTree, postMediaFolder, postMoveMediaFolder, updateMediaFolder,
} from '../../../services/cortizol/media-tree/mediaTreeService';
// Context
import { useAppContext } from '../../../store/AppContext';

/**
 * Media List View
 * @returns {JSX.Element}
 */
function MediaList() {
  // Hooks
  const navigate = useNavigate();
  const [searchParam, setSearchParams] = useSearchParams();
  const [, dispatch] = useAppContext();
  // Params
  const pageNumber = searchParam.get('pageNumber') || PAGINATION_DEFAULT_NUMBER;
  const pageSize = searchParam.get('pageSize') || PAGINATION_DEFAULT_SIZE;
  const sort = searchParam.get('sort') || null;
  const order = searchParam.get('order') || null;
  const folderId = searchParam.get('folderId') || 'root';

  // Handlers

  /**
   * Handle row
   * @param {object} row - The row object
   * @param {string} row.id - The row id
   * @returns {void}
   */
  const handleRowNavigate = (row) => navigate(
    `/media/${row.id}?folderId=${folderId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
  );

  return (
    <div className="padding-l">
      <MediaGallery
        translations={fr.cortizol.mediaGallery}
        options={{
          isModal: false,
          singleSelection: false,
          defaultSelectedRows: [],
        }}
        params={{
          pageNumber: +pageNumber, pageSize: +pageSize, sort, order, folderId,
        }}
        callbacks={{
          setParams: setSearchParams,
          handleRowNavigate,
          // @ts-ignore
          notify: ({ message, type }) => dispatch({
            type: 'SET_MESSAGE',
            payload: { text: message, type },
          }),
        }}
        callbacksAsync={{
          uploadMedia: postUploadMedia,
          archiveMedia: postArchiveMedia,
          getLocales: getAlllocales,
          getMediasList: getAllMedia,
          deleteMediaFolder,
          getMediaTree: getMyMediaTree,
          postAddMediaFolder: postMediaFolder,
          postMoveMediaFolder,
          updateMediaFolder,
        }}
      />
    </div>
  );
}

export default MediaList;
